var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  MATRIX_FUNCTIONS: () => MATRIX_FUNCTIONS,
  MATRIX_FUNCTION_TRANSLATE: () => MATRIX_FUNCTION_TRANSLATE,
  default: () => matrix_default
});
var import_math = __toModule(require("../helper/math"));
var import_utils = __toModule(require("../helper/utils"));
const MATRIX_FUNCTION_TRANSLATE = {
  "AJUSTA MATRIZ": "adjustMatrix",
  "A\xD1ADE NUMERO MATRIZ": "appendMatrixNumber",
  "A\xD1ADE TEXTO MATRIZ": "appendMatrixText",
  "CALCULA DIAS MATRIZ": "dateCalculateDaysMatrix",
  "CAMBIAR FECHA MATRIZ": "dateReverseMatrix",
  "CONCATENAR MATRIZ": "concatenateMatrix",
  "CORTAR APELLIDOS MATRIZ": "parseNameMatrix",
  "CONTIENE TEXTO MATRIZ": "containTextMatrix",
  "CREA MATRIZ NUMEROS": "buildMatrixNumber",
  "DERECHA MATRIZ": "rightNumberMatrix",
  "DERECHA NUMERO MATRIZ": "rightNumberMatrix",
  "DERECHA TEXTO MATRIZ": "rightTextMatrix",
  "DISTINTO MATRIZ": "unequalMatrix",
  "DISTINTO TEXTO MATRIZ": "unequalTextMatrix",
  "DIVISION MATRIZ": "divideMatrix",
  "ELIMINAR DUPLICADOS MATRIZ": "uniqueMatrix",
  "ELIMINAR VAC\xCDOS MATRIZ": "removeEmptiesMatrix",
  "FECHA XML MATRIZ": "dateHumanizeMatrix",
  "IGUAL MATRIZ": "equalMatrix",
  "INDEX MATRIZ": "indexOfMatrix",
  "INDEX PRIMER TEXTO MATRIZ": "indexFirstTextValueMatrix",
  "INDEX MAXIMO MATRIZ": "indexMaximumMatrix",
  "INDEX MINIMO MATRIZ": "indexMinimumMatrix",
  "INDEX SUMA MATRIZ": "indexSumMatrix",
  "IZQUIERDA MATRIZ": "leftNumberMatrix",
  "IZQUIERDA NUMERO MATRIZ": "leftNumberMatrix",
  "IZQUIERDA TEXTO MATRIZ": "leftTextMatrix",
  "MATCH NUMERO MATRIZ": "matchNumberMatrix",
  "MATCH TEXTO MATRIZ": "matchTextMatrix",
  "MAXIMO MATRIZ": "maximumMatrix",
  "MAYOR MATRIZ": "largerMatrix",
  "MAYOR O IGUAL MATRIZ": "largerEqMatrix",
  "MENOR MATRIZ": "smallerMatrix",
  "MENOR O IGUAL MATRIZ": "smallerEqMatrix",
  "MINIMO MATRIZ": "minimumMatrix",
  "MISMO TEXTO MATRIZ": "equalTextMatrix",
  "MULTIPLICACION MATRIZ": "multiplyMatrix",
  "NO CONTIENE TEXTO MATRIZ": "notContainTextMatrix",
  "NO VAC\xCDO MATRIZ": "notEmptyMatrix",
  "REDONDEA MATRIZ": "roundMatrix",
  "REDONDEA ENTERO MATRIZ": "roundIntegerMatrix",
  "RESTA MATRIZ": "subtractMatrix",
  "POSICION MATRIZ": "positionMatrix",
  "SANITIZAR MATRIZ": "sanitizeMatrix",
  "SUMA MATRIZ": "addMatrix",
  "TRUNCAR ENTERO MATRIZ": "floorMatrix",
  "VAC\xCDO MATRIZ": "emptyMatrix"
};
const MATRIX_FUNCTIONS = Object.values(MATRIX_FUNCTION_TRANSLATE);
const addMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.addFunction, ...values);
};
const adjustMatrix = (matrix1, matrix2) => {
  const validatedMatrix1 = Array.isArray(matrix1) ? matrix1 : [matrix1];
  const validatedMatrix2 = Array.isArray(matrix2) ? matrix2 : [matrix2];
  if (!Array.isArray(validatedMatrix1)) {
    const resultMatrix = new Array(validatedMatrix2.length);
    resultMatrix.fill((0, import_utils.fillingValue)(validatedMatrix1));
    resultMatrix[0] = validatedMatrix1;
    return resultMatrix;
  }
  if (!Array.isArray(validatedMatrix2)) {
    return [validatedMatrix1[0]];
  }
  const lengthDifference = validatedMatrix2.length - validatedMatrix1.length;
  if (lengthDifference > 0) {
    const filling = (0, import_utils.fillingValue)(validatedMatrix1[0]);
    return validatedMatrix1.concat(new Array(lengthDifference).fill(filling));
  }
  return validatedMatrix1.slice(0, validatedMatrix2.length);
};
const appendMatrixNumber = (...values) => {
  return (0, import_math.appendMatrixFunction)(import_utils.ARG.SCALAR.NUMBER, ...values);
};
const appendMatrixText = (...values) => {
  return (0, import_math.appendMatrixFunction)(import_utils.ARG.SCALAR.STRING, ...values);
};
const buildMatrixNumber = (value) => {
  return Array.isArray(value) ? value : [value];
};
const concatenateMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.concatenateFunction, ...values);
};
const containTextMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.containTextFunction, ...values);
};
const dateCalculateDaysMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.dateCalculateDaysFunction, ...values);
};
const dateHumanizeMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.dateHumanizeFunction, ...values);
};
const dateReverseMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.dateReverseFunction, ...values);
};
const divideMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.divideFunction, ...values);
};
const equalMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.equalFunction, ...values);
};
const equalTextMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.equalTextFunction, ...values);
};
const emptyMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.emptyFunction, ...values);
};
const floorMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.floorFunction, ...values);
};
const indexFirstTextValueMatrix = import_math.indexFirstTextValueFunction;
const indexOfMatrix = import_math.indexFunction;
const indexMaximumMatrix = import_math.indexMaximumFunction;
const indexMinimumMatrix = import_math.indexMinimumFunction;
const indexSumMatrix = import_math.indexSumFunction;
const largerMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.largerFunction, ...values);
};
const largerEqMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.largerEqFunction, ...values);
};
const leftNumberMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.leftNumberFunction, ...values);
};
const leftTextMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.leftTextFunction, ...values);
};
const matchNumberMatrix = import_math.matchNumberFunction;
const matchTextMatrix = import_math.matchTextFunction;
const maximumMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.maximumFunction, ...values);
};
const minimumMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.minimumFunction, ...values);
};
const multiplyMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.multiplyFunction, ...values);
};
const notContainTextMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.notContainTextFunction, ...values);
};
const notEmptyMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.notEmptyFunction, ...values);
};
const parseNameMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.parseNameFunction, ...values);
};
const positionMatrix = import_math.positionFunction;
const removeEmptiesMatrix = import_math.removeEmptiesFunction;
const rightNumberMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.rightNumberFunction, ...values);
};
const rightTextMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.rightTextFunction, ...values);
};
const roundMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.roundFunction, ...values);
};
const roundIntegerMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.roundIntegerFunction, ...values);
};
const smallerMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.smallerFunction, ...values);
};
const sanitizeMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.sanitizeFunction, ...values);
};
const smallerEqMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.smallerEqFunction, ...values);
};
const subtractMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.subtractFunction, ...values);
};
const unequalMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.unequalFunction, ...values);
};
const unequalTextMatrix = (...values) => {
  return (0, import_utils.operateMatrix)(import_math.unequalTextFunction, ...values);
};
const uniqueMatrix = import_math.uniqueFunction;
var matrix_default = {
  addMatrix,
  adjustMatrix,
  appendMatrixNumber,
  appendMatrixText,
  buildMatrixNumber,
  concatenateMatrix,
  containTextMatrix,
  dateCalculateDaysMatrix,
  dateHumanizeMatrix,
  dateReverseMatrix,
  divideMatrix,
  emptyMatrix,
  equalMatrix,
  equalTextMatrix,
  floorMatrix,
  indexFirstTextValueMatrix,
  indexOfMatrix,
  indexMaximumMatrix,
  indexMinimumMatrix,
  indexSumMatrix,
  largerEqMatrix,
  largerMatrix,
  leftNumberMatrix,
  leftTextMatrix,
  matchNumberMatrix,
  matchTextMatrix,
  maximumMatrix,
  minimumMatrix,
  multiplyMatrix,
  notContainTextMatrix,
  notEmptyMatrix,
  parseNameMatrix,
  removeEmptiesMatrix,
  rightNumberMatrix,
  rightTextMatrix,
  roundMatrix,
  roundIntegerMatrix,
  positionMatrix,
  sanitizeMatrix,
  smallerEqMatrix,
  smallerMatrix,
  subtractMatrix,
  unequalMatrix,
  unequalTextMatrix,
  uniqueMatrix
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MATRIX_FUNCTIONS,
  MATRIX_FUNCTION_TRANSLATE
});
